import { reactive, ref } from "vue";

const alerts = reactive<Record<string, any>>({});

function addAlert(message: string, expireInSeconds: number){
	if(!message) return;
	const timeout = setTimeout(() => {
		delete alerts[timeout];
	}, expireInSeconds);

	alerts[timeout] = { message };
}

export default function (){

	return {
		addAlert,
		alerts
	}
}